import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'
import * as code8OcurrencesActions from 'action/code8occurrences'
import * as reportActions from 'action/report'
import ContentHeader from 'component/utils/ContentHeader'
import OccurrencesCode8 from 'component/report/occurrencescode8/PreviousDayOccurrencesCode8'
import OccurrencesCode8Header from 'component/report/occurrencescode8/OccurrencesCode8Header'
import BranchFilterOccurrencesCode8 from 'component/report/occurrencescode8/BranchFilterOccurrencesCode8'
import FeedbackError from 'component/utils/FeedbackError'

const CODE_8_REPORT_CODE = 16

class PreviousDayOccurrencesCode8Container extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    fetchCode8Occurrences: PropTypes.func.isRequired,
    fetchAsyncReports: PropTypes.func.isRequired,
    fetchReports: PropTypes.func.isRequired,
    fetchCode8OccurrencesSuccess: PropTypes.func.isRequired,
    error: PropTypes.object,
    code8Occurrences: PropTypes.object,
    filters: PropTypes.object,
    auth: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props)

    const {
      auth: { user },
    } = this.props

    let filtersVisible = false
    let code8OccurrenceInfoVisible = true
    if (user.locationCode === '999') {
      filtersVisible = true
      code8OccurrenceInfoVisible = false
    }

    this.state = {
      filtersVisible,
      code8OccurrenceInfoVisible,
      controlView: false,
    }
  }

  componentWillMount() {
    const { auth } = this.props

    if (auth.user.locationCode !== '999') {
      this.fetchAsyncReports({})
    }
  }

  handleFetchCode8Occurrences = (values) => {
    this.setState({ controlView: true })

    this.fetchAsyncReports(values)
  }

  fetchAsyncReports = (filters) => {
    const { auth, fetchAsyncReports, fetchCode8OccurrencesSuccess } = this.props

    fetchAsyncReports(
      auth.user.dsToken,
      { tpReport: CODE_8_REPORT_CODE },
      { ...filters, idBranch: this.getIdBranch(auth) },
      fetchCode8OccurrencesSuccess
    )
  }

  getIdBranch = (auth) => auth.user.locationCode.padStart(4, '0')

  componentWillReceiveProps() {
    const { filtersVisible, controlView } = this.state
    const {
      code8Occurrences,
      auth: { user },
    } = this.props

    if (
      filtersVisible &&
      code8Occurrences &&
      controlView &&
      user.locationCode === '999'
    ) {
      this.invertStates()
    }
  }

  getCsv = () => {
    const {
      fetchAsyncReports,
      filters,
      auth: { user },
    } = this.props

    const values = {
      tpReport: 6,
    }

    fetchAsyncReports(user.dsToken, values, filters)
  }

  getCsvRecurrence = () => {
    const {
      fetchReports,
      filters,
      auth: { user },
    } = this.props

    const values = {
      tpReport: 7,
    }

    fetchReports(user.dsToken, values, filters)
  }

  invertStates() {
    let { filtersVisible, code8OccurrenceInfoVisible } = this.state

    filtersVisible = !filtersVisible
    code8OccurrenceInfoVisible = !code8OccurrenceInfoVisible

    this.setState({ filtersVisible })
    this.setState({ code8OccurrenceInfoVisible })
  }

  renderError(message) {
    if (message.dsMessage) {
      const text = translate('form.data.invalid')

      return (
        <FeedbackError
          className='margin-top-double'
          message={message.dsMessage}
          text={text}
        />
      )
    }
  }

  render() {
    const { translate, error, code8Occurrences, filters, auth } = this.props

    const { filtersVisible, code8OccurrenceInfoVisible } = this.state

    return (
      <section>
        <ContentHeader>
          {translate('mobile.previousDayOccurrences-code8')}
        </ContentHeader>

        <OccurrencesCode8Header
          translate={translate}
          pageName={translate('mobile.previousDayOccurrences-code8')}
        />

        {error && this.renderError(error.message)}

        {filtersVisible && (
          <BranchFilterOccurrencesCode8
            translate={translate}
            fetchCode8Occurrences={this.handleFetchCode8Occurrences}
            auth={auth}
          />
        )}

        {code8OccurrenceInfoVisible && (
          <OccurrencesCode8
            translate={translate}
            code8Occurrences={code8Occurrences}
            filters={filters}
            getCsv={this.getCsv}
            getCsvRecurrence={this.getCsvRecurrence}
          />
        )}
      </section>
    )
  }
}

/*
 * Maps redux state to component props
 */
/* istanbul ignore next */
const mapStateToProps = (
  { code8OccurrencesReducer, reportReducer }
) => ({
  code8Occurrences: code8OccurrencesReducer.record,
  error: code8OccurrencesReducer.error,
  filters: code8OccurrencesReducer.filters,
  report: reportReducer.get.record,
})

/*
 * Maps actions and dispatch them to component props
 */
/* istanbul ignore next */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...code8OcurrencesActions, ...reportActions }, dispatch)

/*
 * Connects component to I18next
 */
const OccurrencesCode8Translated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(PreviousDayOccurrencesCode8Container)

/*
 * Exports component connected to redux as default
 */
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OccurrencesCode8Translated)

/*
 * Exports as component
 */
export { PreviousDayOccurrencesCode8Container }
